import { PERFIS_CLIENTE } from '@/libs/perfilCliente';

import { dashboardSomenteDoacao } from '@/utils/orderReadScope';

export function getDashboardNav() {
  const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
  const perfilNome = perfilLogado.perfil_acesso_nome || '';

  let route = 'dashboard-equipe-vendas';
  let icon = 'TrendingUpIcon';

  if (perfilNome === 'AdminDKP') {
    route = 'dashboard-admin-dkp';
    icon = 'ActivityIcon';
  } else if (perfilNome === 'AdminHanes' || perfilNome === 'Administrador') {
    route = 'dashboard-executivo';
    icon = 'BarChart2Icon';
  } else if (PERFIS_CLIENTE.includes(perfilNome)) {
    route = 'dashboard-cliente';
    icon = 'PieChartIcon';
  } else if (perfilNome === 'Representante' || perfilNome === 'Supervisor' || perfilNome === 'Equipe de Vendas') {
    route = 'dashboard-equipe-vendas';
    icon = 'TrendingUpIcon';
  }

  const navItems = [];

  if (perfilNome === 'Representante' || perfilNome === 'Supervisor' || perfilNome === 'Equipe de Vendas') {
    navItems.push({
      title: 'Mural',
      route: 'dashboard-mural',
      icon: 'HomeIcon',
      action: 'read',
      resource: 'DashboardEquipeVendas',
    });
    navItems.push({
      // Representante trabalha só com doações → menu vira "Dashboard de Doação".
      title: dashboardSomenteDoacao(perfilNome, localStorage.getItem('tenantSlug')) ? 'Dashboard de Doação' : 'Vendas e Metas',
      route: 'dashboard-equipe-vendas',
      icon: 'TrendingUpIcon',
      action: 'read',
      resource: 'DashboardEquipeVendas',
    });
  } else {
    navItems.push({
      title: 'Dashboard',
      route,
      icon,
      action: 'read',
      resource: route === 'dashboard-admin-dkp' ? 'all' : route === 'dashboard-executivo' ? 'AdminHanes' : route === 'dashboard-cliente' ? 'DashboardCliente' : 'DashboardEquipeVendas',
    });
  }

  return navItems;
}

export default getDashboardNav();
